export default "__VITE_ASSET__61_H1CAg__"